export enum AvatarSize {
  Small = 'small',
  Default = 'default',
  Large = 'large'
}
